import type { Dispatch, AnyAction } from 'redux';

import SystemNotificationFM from 'af-root/scenes/Platform/SystemNotifications/formModel';

import type SystemNotificationRequestModel from 'ab-requestModels/systemNotification.requestModel';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import API from 'af-constants/routes/api';

export function createSystemNotification(form: SystemNotificationRequestModel) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const parsedForm = SystemNotificationFM.fromFMtoRM(form);
			return await http.post<SystemNotificationRequestModel[]>(API.V1.SYSTEM_NOTIFICATIONS.ROOT, parsedForm);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findAllSystemNotifications() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<SystemNotificationRequestModel[]>(API.V1.SYSTEM_NOTIFICATIONS.ROOT);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function deleteSystemNotification(id: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.delete(API.V1.SYSTEM_NOTIFICATIONS.DELETE(id));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
